// extracted by mini-css-extract-plugin
export default {"actionButtons":"aggregatorTable_actionButtons__7zBaj","closingBalance":"aggregatorTable_closingBalance__aQ1s4","alignRight":"aggregatorTable_alignRight__IbQp7"};